import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { inr } from "@/lib/format";

export default function ProductCard({ product, index = 0 }) {
  const lowStock = product.total_stock > 0 && product.total_stock <= 5;
  const soldOut = product.total_stock === 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06 }}
    >
      <Link
        to={`/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block"
      >
        <div className="relative overflow-hidden bg-zinc-900 aspect-[3/4]">
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3 flex flex-col gap-2">
            {product.featured && (
              <span className="bg-brand text-black font-mono text-[10px] font-bold uppercase tracking-widest px-2 py-1">
                Featured
              </span>
            )}
            {product.compare_at && (
              <span className="bg-white text-black font-mono text-[10px] font-bold uppercase tracking-widest px-2 py-1">
                Sale
              </span>
            )}
          </div>
          {soldOut && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <span className="font-mono text-xs uppercase tracking-widest text-white border border-white px-3 py-1">Sold Out</span>
            </div>
          )}
          {lowStock && !soldOut && (
            <span className="absolute bottom-3 left-3 bg-red-500 text-white font-mono text-[10px] font-bold uppercase tracking-widest px-2 py-1">
              Only {product.total_stock} left
            </span>
          )}
        </div>
        <div className="mt-3 space-y-1">
          <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{product.category}</p>
          <h3 className="text-sm font-semibold text-zinc-100 group-hover:text-brand transition-colors">{product.name}</h3>
          <div className="flex items-center gap-2">
            <span className="font-mono text-sm text-zinc-100">{inr(product.price)}</span>
            {product.compare_at && (
              <span className="font-mono text-xs text-zinc-600 line-through">{inr(product.compare_at)}</span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
